<template>
    <plotlyjs-basic-chart :target-id="targetId"
                          :target-css-classes="cssClasses"
                          :bc-options="mergeDicts(defaultOptions, bcOptions)"
                          :height="height"
                          :width="width"
                          :bc-data="bcData"
                          :bc-layout="bcLayout">
    </plotlyjs-basic-chart>
</template>


<script>
import PlotlyJSBasicChart from './BasicChart'

export default {
  components: {
    'plotlyjs-basic-chart': PlotlyJSBasicChart,
  },

  props: {
    targetId: {
      type: String
    },
    cssClasses: {
      type: String,
      default: 'chart'
    },
    bcData: {
      type: Array,
      required: true,
    },
    bcLayout: {
      type: Object,
      default: function () {
        return {};
      }
    },
    bcOptions: {
      type: Object,
      default: function () {
        return {};
      }
    },
    height: {
      type: Number
    },
    width: {
      type: Number
    },
  },

  data: function () {
    return {
      defaultOptions: {
        displayModeBar: false
      },
    };
  },

  methods: {
    mergeDicts: function (defaultDict, newDict) {
      for (var key in this.newDict) {
        defaultDict[key] = this.newDict; 
      }
      return defaultDict;
    },
  }
};
</script>


<style scoped>
 .chart {
     height: 100%;
     width: 100%;
 }
</style>



// WEBPACK FOOTER //
// LSBasicChart.vue?9bcdd3fc